import React from 'react'
import { AstonFundersDashboard } from './components/AstonFundersDashboard'

const AstonFundersApp: React.FC = () => {
  return <AstonFundersDashboard />
}

export default AstonFundersApp
